import classNames from "classnames";
import styles from "./loader.module.scss";

type Props = {
  className?: string;
  warpperClassName?: string;
  style?: React.CSSProperties
};

export const Loader = ({ className }: Props) => {
  return <span className={classNames(styles.loader, className)}/>;
};

export const FlexLoader = ({ className, warpperClassName, style }: Props) => {
  return (
    <div className={classNames(styles.flexLoader, warpperClassName)} style={style}>
      <Loader className={className} />
    </div>
  );
};

export const GlobalLoader = ({ className }: Props) => {
  return (
    <div className={classNames(styles.globalLoader)}>
      <Loader className={className} />
    </div>
  );
};
